/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_From_EnInputs */

const en_language_from_en = /** @type {(inputs: Language_From_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de_language_from_en = /** @type {(inputs: Language_From_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englischen`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {Language_From_EnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const language_from_en = /** @type {((inputs?: Language_From_EnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_From_EnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_language_from_en(inputs)
	return en_language_from_en(inputs)
});